<script>

import { ref } from "vue";
const currentDate = ref(new Date());

export default {
    data() {
        return {
            quantity: 1,
            title: "Book a Service",
            text: "Service",
            text1: "Book a Service",
            Floor: ["0-2 Hrs", "2-3 Hrs", "3-4 Hrs"],
            FloorOne: ["1st Floor", "2nd Floor", "3rd Floor"],
            startdate: currentDate,
            dateFormat: "dd-MM-yyyy",
            currentStep: 0, // This keeps track of the current step
			steps: [
				{ title: "Basic Information" },
				{ title: "Booking Schedule" },
				{ title: "Collection Address Details" },
				{ title: "Delivery Address Details" },
				{ title: "Additional Items" },
				{ title: "Review Order" },
				{ title: "Checkout" },
        	],
        }
    },
    methods: {
		goToNextStep() {
				// Check if there is a next step
				if (this.currentStep < this.steps.length) {
				this.currentStep += 1;
			}
		},
		goToPreviousStep() {
				// Check if there is a previous step
				if (this.currentStep > 0) {
				this.currentStep -= 1;
			}
		},
        increaseQuantity() {
            this.quantity++;
        },
        decreaseQuantity() {
            if (this.quantity > 1) {
                this.quantity--;
            }
        },
    },
}
</script>

<template>
    <layout-header></layout-header>
    <services-breadcrumb :title="title" :text="text" :text1="text1" />
     <!-- Page Wrapper -->
     <div class="page-wrapper">
        <div class="content">
            <div class="container">
				<div class="fieldset-wizard request-wizard">
					<div class="row">
						<div class="col-xl-3 col-lg-4 theiaStickySidebar">
							<div class="card shadow-none bg-light-500 booking-sidebar request-sidebar mb-4 mb-lg-0">
								<div class="card-body">
									<div class="service-info bg-white d-flex align-items-center mb-3">
										<span class="avatar avatar-xl me-2 flex-shrink-0">
											<img src="@/assets/img/service-request.jpg" class="border-0" alt="img">
										</span>
										<div>
											<h5 class="mb-1">Removals</h5>
											<p class="fs-14">35 Providers Available</p>
										</div>
									</div>
									<div class="booking-wizard p-0">
										<h6 class="mb-3 fw-semibold">Steps</h6>
										<ul class="wizard-progress" id="bokingwizard">
											<li class="pb-4" :class="[{ 'active ': currentStep === 0 , 'activated' : currentStep > 0 }]">
												<span>Basic Information</span>
											</li>
											<li class="pb-4" :class="[{ 'active' : currentStep === 1 , 'activated' : currentStep > 1 }]">
												<span>Booking Schedule</span>															
											</li>
											<li class="pb-4" :class="[{ 'active' : currentStep === 2 , 'activated' : currentStep > 2 }]">
												<span>Collection Address Details</span>															
											</li>
											<li class="pb-4" :class="[{ 'active' : currentStep === 3 , 'activated' : currentStep > 3 }]">
												<span>Delivery Address Details</span>															
											</li>
											<li class="pb-4" :class="[{ 'active' : currentStep === 4 , 'activated' : currentStep > 4 }]">
												<span>Additional Items</span>															
											</li>
											<li class="pb-4" :class="[{ 'active' : currentStep === 5 , 'activated' : currentStep > 5 }]">
												<span>Review Order</span>	
											</li>
											<li>
												<span>Checkout</span>																
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-9 col-lg-8">
							<fieldset id="first-field" v-show="currentStep === 0">
								<div class="card flex-fill">
									<div class="card-body">
										<h5 class="mb-3">Personal Details</h5>
										<form action="/service/service-request">
											<div>
												<h6 class="mb-3 fs-16 fw-medium">Basic Information</h6>
												<div class="form-check mb-4">
													<input class="form-check-input" type="checkbox" value="" id="remember_me">
													<label class="form-check-label" for="remember_me">
														Is the Name and Contact details the same as on your Profile?
													</label>
												</div>
												<div class="row">
													<div class="col-md-6">
														<div class="mb-4">
															<div class="form-floating">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">First Name <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-6">
														<div class="mb-4">
															<div class="form-floating">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Last Name <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-6">
														<div class="mb-4">
															<div class="form-floating">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Email Address <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-6">
														<div class="mb-4">
															<div class="form-floating">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Phone Number <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-12">
														<div class="mb-4 border-top pt-4">
															<div class="position-relative">
																<label class="fs-12 select-floating-label">Floor Level <span class="text-danger">*</span></label>
                                                                <vue-select 
                                                                    :options="Floor"
                                                                    id="floorlevel"
                                                                    placeholder="0-2 Hrs"
                                                                />
															</div>
														</div>
													</div>
													<div class="col-md-12">
														<div class="form-check mb-4">
															<input class="form-check-input" type="checkbox" value="" id="cost_check">
															<label class="form-check-label" for="cost_check">
																Do you live in the CC Zone? (Costs $15 extra)
															</label>
														</div>
													</div>
												</div>
											</div>
											<div class="text-end">
												<button type="button" @click="goToNextStep" class="btn btn-linear-primary next_btn">Next Step</button>
											</div>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset :class="currentStep === 1 ? 'd-block' : 'd-none'">
								<div class="card flex-fill">
									<div class="card-body">
										<h5 class="mb-3">Booking Schedule</h5>
										<form action="/service/service-request">
											<div>
												<div class="row">
													<div class="col-md-12">
														<div class="mb-4">
															<div class="form-floating  input-icon position-relative	">
																<!-- <input type="email" class="form-control datetimepicker" placeholder=""> -->
                                                                <date-picker
                                                                    v-model="startdate"
                                                                    placeholder=""
                                                                    class="datetimepicker form-control"
                                                                    :editable="true"
                                                                    :clearable="false"
                                                                    :input-format="dateFormat"
                                                                />
																<!-- <label class="fs-14">Select Date and Time <span class="text-danger">*</span></label> -->
																<span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
															</div>
														</div>
													</div>
												</div>
												<div class="mb-3">
													<h6 class="fs-16 fw-medium mb-3">Number of People in Luton Vans</h6>
													<div class="custom-increment">
														<label class="d-block mb-2">Number of People in Luton Vans</label>
														<div class="d-flex align-items-center">
															<button type="button" class="quantity-plus btn quantity-btn" @click="increaseQuantity" data-type="plus" data-field="">
																<span><i class="fas fa-plus"></i></span>
															</button>
															<input type="text" id="quantity" class="input-number" :value="quantity" readonly>
															<button type="button" class="quantity-minus btn quantity-btn" @click="decreaseQuantity" data-type="minus" data-field="">
																<span><i class="fas fa-minus"></i></span>
															</button>
														</div>
													</div>
												</div>
												<div class="form-check mb-4">
													<input class="form-check-input" type="checkbox" value="" id="check_2">
													<label class="form-check-label" for="check_2">
														Same Number of People in All Vans
													</label>
												</div>
												<div class="mb-4">
													<h6 class="fs-16 mb-3 fw-semibold">Number of People in All Vans</h6>
													<p class="mb-2">Number of People in All Vans</p>
													<div class="d-flex align-items-center flex-wrap row-gap-3">
														<div class="form-check me-3">
															<input class="form-check-input" type="radio" name="timing" id="hour-radio-1" checked="">
															<label class="form-check-label" for="hour-radio-1">
																2 (£70 Per Hour)
															</label>
														</div>
														<div class="form-check">
															<input class="form-check-input" type="radio" name="timing" id="hour-radio-2">
															<label class="form-check-label" for="hour-radio-2">
																3 (£90 Per Hour)
															</label>
														</div>
													</div>
												</div>
											</div>
											<div class="d-flex justify-content-end align-items-center">
												<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light d-inline-flex align-items-center prev_btn me-2">Back</a>
												<button type="button" @click="goToNextStep" class="btn btn-linear-primary next_btn">Next Step</button>
											</div>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset :class="currentStep === 2 ? 'd-block' : 'd-none'">
								<div class="card flex-fill">
									<div class="card-body">
										<h5 class="mb-3">Collection Address Details</h5>
										<form action="/service/service-request">
											<div>
												<div class="row">
													<div class="col-md-12">
														<div class="mb-4">
															<div class="form-floating  input-icon position-relative	">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Address <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-12">
														<div class="mb-4">
															<div class="form-floating  input-icon position-relative	">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Postal Code <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-12">
														<div class="d-flex align-items-center flex-wrap row-gap-3 mb-3">
															<div class="form-check me-3">
																<input class="form-check-input" type="radio" name="property" id="property-radio-1" checked="">
																<label class="form-check-label" for="property-radio-1">
																	House
																</label>
															</div>
															<div class="form-check me-3">
																<input class="form-check-input" type="radio" name="property" id="property-radio-2">
																<label class="form-check-label" for="property-radio-2">
																	Flat
																</label>
															</div>
															<div class="form-check">
																<input class="form-check-input" type="radio" name="property" id="property-radio-3">
																<label class="form-check-label" for="property-radio-3">
																	Business Premise
																</label>
															</div>
														</div>
													</div>
												</div>
												<div class="mb-3">
													<div class="custom-increment">
														<label class="d-block mb-2">Number of Bedrooms</label>
														<div class="d-flex align-items-center">
															<button type="button" class="quantity-plus btn quantity-btn" @click="increaseQuantity" data-type="plus" data-field="">
																<span><i class="fas fa-plus"></i></span>
															</button>
															<input type="text" id="increment-count" class="input-number" :value="quantity" readonly >
															<button type="button" class="quantity-minus btn quantity-btn" @click="decreaseQuantity" data-type="minus" data-field="">
																<span><i class="fas fa-minus"></i></span>
															</button>
														</div>
													</div>
												</div>
												<div class="mb-4">
													<div class="position-relative">
														<label class="fs-12 select-floating-label">Floor Level <span class="text-danger">*</span></label>
                                                        <vue-select 
                                                            :options="FloorOne"
                                                            id="floorlevelone"
                                                            placeholder="1st Floor"
                                                        />
													</div>
												</div>
												<div class="form-check mb-4">
													<input class="form-check-input" type="checkbox" value="" id="check_3">
													<label class="form-check-label" for="check_3">
														There is a lift/elevator at the address
													</label>
												</div>
											</div>
											<div class="d-flex justify-content-end align-items-center">
												<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light d-inline-flex align-items-center prev_btn me-2">Back</a>
												<button type="button" @click="goToNextStep" class="btn btn-linear-primary next_btn">Next Step</button>
											</div>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset :class="currentStep === 3 ? 'd-block' : 'd-none'">
								<div class="card flex-fill">
									<div class="card-body">
										<h5 class="mb-3">Delivery Address Details</h5>
										<form action="/service/service-request">
											<div>
												<div class="row">
													<div class="col-md-12">
														<div class="mb-4">
															<div class="form-floating  input-icon position-relative	">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Address <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-12">
														<div class="mb-4">
															<div class="form-floating  input-icon position-relative	">
																<input type="email" class="form-control" placeholder="">
																<label class="fs-14">Postal Code <span class="text-danger">*</span></label>
															</div>
														</div>
													</div>
													<div class="col-md-12">
														<div class="d-flex align-items-center flex-wrap row-gap-3 mb-3">
															<div class="form-check me-3">
																<input class="form-check-input" type="radio" name="property" id="property-radio-4" checked="">
																<label class="form-check-label" for="property-radio-4">
																	House
																</label>
															</div>
															<div class="form-check me-3">
																<input class="form-check-input" type="radio" name="property" id="property-radio-5">
																<label class="form-check-label" for="property-radio-5">
																	Flat
																</label>
															</div>
															<div class="form-check">
																<input class="form-check-input" type="radio" name="property" id="property-radio-6">
																<label class="form-check-label" for="property-radio-6">
																	Business Premise
																</label>
															</div>
														</div>
													</div>
												</div>
												<div class="mb-3">
													<div class="custom-increment">
														<label class="d-block mb-2">Number of Bedrooms</label>
														<div class="d-flex align-items-center mb-3">
															<button type="button" class="quantity-plus btn quantity-btn" @click="increaseQuantity" data-type="plus" data-field="">
																<span><i class="fas fa-plus"></i></span>
															</button>
															<input type="text" id="increment-count2" class="input-number" :value="quantity" readonly >
															<button type="button" class="quantity-minus btn quantity-btn" @click="decreaseQuantity" data-type="minus" data-field="">
																<span><i class="fas fa-minus"></i></span>
															</button>
														</div>
													</div>
												</div>
												<div class="mb-4">
													<div class="position-relative">
														<label class="fs-12 select-floating-label">Floor Level <span class="text-danger">*</span></label>
														<vue-select 
                                                            :options="FloorOne"
                                                            id="floorleveltwo"
                                                            placeholder="1st Floor"
                                                        />
													</div>
												</div>
												<div class="form-check mb-4">
													<input class="form-check-input" type="checkbox" value="" id="check_4">
													<label class="form-check-label" for="check_4">
														There is a lift/elevator at the address
													</label>
												</div>
											</div>
											<div class="d-flex justify-content-end align-items-center">
												<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light d-inline-flex align-items-center prev_btn me-2">Back</a>
												<button type="button" @click="goToNextStep" class="btn btn-linear-primary next_btn">Next Step</button>
											</div>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset :class="currentStep === 4 ? 'd-block' : 'd-none'">
								<div class="card flex-fill">
									<div class="card-body">
										<h5 class="mb-3">Additional Items</h5>
										<form action="/service/service-request">
											<div class="mb-3">
												<label class="form-label d-block">Please add Pictures or Videos</label>									
												<div class="d-flex align-items-center justify-content-center upload-field flex-column">
													<span class="d-block text-center mb-2"><img src="@/assets/img/icons/icon-upload.svg" alt=""></span>
													<p class="fs-14 text-center mb-2">Drag and drop your files here to upload <span class="d-block mt-2">Or</span></p>
													<div class="file-upload btn btn-linear-primary h-auto mb-2">
														Browse Files
														<input type="file" accept="video/image">
													</div>
													<p class="text-center fs-14">Only .jpg .png file types allowed and file <br>size must be less than 100 MB</p>
												</div>
											</div>
											<div class="mb-3">
												<label class="form-label">Additional Notes/Special Requirements</label>
												<textarea rows="3" class="form-control"></textarea>
											</div>
											<div class="d-flex justify-content-end align-items-center">
												<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light d-inline-flex align-items-center prev_btn me-2">Back</a>
												<button type="button" @click="goToNextStep" class="btn btn-linear-primary next_btn">Next Step</button>
											</div>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset :class="currentStep === 5 ? 'd-block' : 'd-none'">
								<div class="flex-fill">
									<div class="review-order">
										<h6 class="fs-16 fw-medium border-bottom mb-3 pb-3">Order Details</h6>
										<div class="d-flex align-items-center justify-content-md-between flex-wrap gap-3">
											<div class="rounded bg-white p-2 text-center review-item">
												<h6 class="fw-medium fs-16 mb-1">Booking Charges</h6>
												<span>£ 42.00</span>
											</div>
											<div class="rounded bg-white p-2 text-center review-item">
												<h6 class="fw-medium fs-16 mb-1">CC Zone</h6>
												<span>£ 0.00</span>
											</div>
											<div class="rounded bg-white p-2 text-center review-item">
												<h6 class="fw-medium fs-16 mb-1">Subtotal</h6>
												<span>£ 280.00</span>
											</div>
											<div class="rounded bg-white p-2 text-center review-item">
												<h6 class="fw-medium fs-16 mb-1">V.A.T</h6>
												<span>£ 0.00</span>
											</div>
											<div class="rounded bg-white p-2 text-center review-item">
												<h6 class="fw-medium fs-16 mb-1">Total Payment</h6>
												<span>£ 322.00</span>
											</div>
										</div>
									</div>
									<div class="card mb-0">
										<div class="card-body">
											<h5 class="mb-3">Review Order</h5>
											<div class="border-bottom mb-3">
												<h6 class="fs-16 fw-medium mb-3">Personal Details</h6>
												<div class="row">
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">First Name</h6>
																<span>Name</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Phone</h6>
																<span>Phone</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Last Name</h6>
																<span>Name</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Booking Estimate</h6>
																<span>2</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Email</h6>
																<span>Email</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">CC Zone</h6>
																<span>CC Zone</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="border-bottom mb-3">
												<h6 class="fs-16 fw-medium mb-3">Booking Schedule</h6>
												<div class="row">
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Luton Van</h6>
																<span>2, 2</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Number of Luton Vans</h6>
																<span>2</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Booking Date/Time</h6>
																<span>26 September 2024</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="border-bottom mb-3">
												<h6 class="fs-16 fw-medium mb-3">Collection Address Details</h6>
												<div class="row">
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Address</h6>
																<span>Address</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Floor Level</h6>
																<span>1</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Phone</h6>
																<span>Phone</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Email</h6>
																<span>Email</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Is there a Lift</h6>
																<span>Yes</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Property Type</h6>
																<span>House</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">First Name</h6>
																<span>Name</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Number of Bedrooms</h6>
																<span>5</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="border-bottom mb-3">
												<h6 class="fs-16 fw-medium mb-3">Delivery Address Details</h6>
												<div class="row">
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Address</h6>
																<span>Address</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Floor Level</h6>
																<span>1</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Phone</h6>
																<span>Phone</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Email</h6>
																<span>Email</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Is there a Lift</h6>
																<span>Yes</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Property Type</h6>
																<span>House</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">First Name</h6>
																<span>Name</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Number of Bedrooms</h6>
																<span>5</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="border-bottom mb-3">
												<h6 class="fs-16 fw-medium mb-3">Additional Details</h6>
												<div class="row">
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Already have items</h6>
																<span>Nil</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Does the car start?</h6>
																<span>Nil</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Largest Items</h6>
																<span>Nil</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Special Notes</h6>
																<span>Notes</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Already bought items</h6>
																<span>No</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Hair Done?</h6>
																<span>Nil</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Items need mounting?</h6>
																<span>Nil</span>
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-6">
														<div class="mb-3">
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Does the car run and drive?</h6>
																<span>Nil</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Do you need furniture assembly?</h6>
																<span>Nil</span>
															</div>
															<div class="mb-2">
																<h6 class="fs-14 fw-medium mb-1">Number of Items that need Assembling</h6>
																<span>1</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="d-flex justify-content-end align-items-center">
												<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light d-inline-flex align-items-center prev_btn me-2">Back</a>
												<router-link to="/" class="btn btn-linear-primary">Checkout</router-link>
											</div>
										</div>
									</div>
								</div>
							</fieldset>
						</div>
					</div>
				</div>
            </div>
        </div>
     </div>
    <!-- /Page Wrapper -->

    <pages-footer></pages-footer>
</template>